import React from "react";


export class ApplicationStatusBadge extends React.Component {
    render() {
        const status = this.props.status;
        var className = "badge badge-pill ";
        switch (status) {
            case 'waiting': className += 'badge-waiting';  break;
            case 'approved': className += 'badge-approved';  break;
            case 'rejected': className += 'badge-rejected';  break;
        }
        return (
            <span className={className}>{translations['applications.status.' + status]}</span>
        )
    }
}

export class ApplicationPaymentStatusBadge extends React.Component {
    render() {
        const status = this.props.status;
        var className = "badge badge-pill ";
        switch (status) {
            case 'none': className += 'badge-waiting';  break;
            case 'payed': className += 'badge-paid';  break;
        }
        return (
            <span className={className}>{translations['applications.payment_status.' + status]}</span>
        )
    }
}
